module.exports = __webpack_public_path__ + "static/img/15.5ad477f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/15.png
// module id = BAZp
// module chunks = 0